AgrimarketServices.service('typeCommitmentsService', ['$rootScope', '$http', '$location', 'currentUserFactory', 'configurationFactory',
    function ($rootScope, $http, $location, currentUserFactory, configurationFactory) {

    	var SendRequest = function (configfile, callback) {
    		$http(configfile)
			    .success(function (data) {
			    	callback(data, null);
			    })
			    .error(function (data, status) {
			    	callback(data, status);
			    });
    	};

    	this.GetTypeCommitments = function (bGetOnlyForContractualisation, callback) {
    		var config = {
    			method: 'GET',
    			url: configurationFactory.Url['Api'] + 'TypeCommitment/GetAll',
				params: { bGetOnlyForContractualisation: bGetOnlyForContractualisation}
    		};
    		SendRequest(config, callback);
    	};
    }]);